import React from 'react';
import './Sponsors.css';

function Sponsors() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const mainSponsor = {
    name: "MEDTRONIC",
    logo: "/images/sponsors/Medtronic-Logo.png",
  };

  const platinumSponsors = [
    {
      name: "ABBOTT INDIA LTD",
      logo: "/images/sponsors/Abbott.jpeg",
    },
    {
      name: "BOSTON SCIENTIFIC",
      logo: "/images/sponsors/Boston-scientific.jpeg",
    },
    {
      name: "MERIL LIFESCIENCES INDIA PVT LTD",
      logo: "/images/sponsors/Meril.jpeg",
     
    }
  ];

  const goldSponsors = [
    {
      name: "BD INDIA",
      logo: "/images/sponsors/BD.png",
    },
    {
      name: "ARTIVION",
      logo: "/images/sponsors/Artivion-new.png",
    },
    {
      name: "RELISYS MEDICAL DEVICES LTD",
      logo: "/images/sponsors/Relisys-new.png",
    },
    {
      name: "EMCURE PHARMACEUTICALS LTD",
      logo: "/images/sponsors/Emcure.jpeg",
    },
    {
      name: "FUSION PHARMA",
      logo: "/images/sponsors/Fusion_new_Logo.jpg",
    }
  ];

  const commonSponsors = [
    { name: "Sahajanand Medical Technologies (SMT)", logo: "/images/sponsors/SMT.jpeg" },
    { name: "W L GORE (INDIA) PRIVATE LTD", logo: "/images/sponsors/Gore.jpeg" },
    { name: "SERVIER INDIA PRIVATE LTD", logo: "/images/sponsors/Servier.jpeg" },
    { name: "SOLVENTUM (KCI)", logo: "/images/sponsors/Solventum_logo.png" },
    { name: "AARUX PHARMACEUTICALS", logo: "/images/sponsors/Aarux.jpeg" },
    { name: "OUTCARE MEDICAL DEVICES PVT LTD", logo: "/images/sponsors/Outcare.png" },
    { name: "MOLNLYCKE HEALTHCARE INDIA PVT LTD", logo: "/images/sponsors/Molnlycke.png" },
    { name: "ZUVENTUS HEALTHCARE LTD", logo: "/images/sponsors/Zuventus.png" },
    { name: "CALREN CARE", logo: "/images/sponsors/calrencare-logo.png" },
    { name: "PHARM PRODUCTS", logo: "/images/sponsors/PharmProducts.png" },
    { name: "SHOCKWAVE", logo: "/images/sponsors/Shockwave-new.jpeg" },
    { name: "CILVORYL DIVISION - VASU ORGANICS", logo: "/images/sponsors/Vasu-organics.jpg" },
    { name: "WOCKHARDT LTD", logo: "/images/sponsors/Wockhardt.png" },
    { name: "ALKEM LABORATORIES", logo: "/images/sponsors/Alkem.png" },
    { name: "ESSITY", logo: "/images/sponsors/Essity_logo.png" },
    { name: "DATT MEDIPRODUCTS PVT LTD", logo: "/images/sponsors/DMP.png" },
    { name: "MATRIX PHARMACORP PRIVATE LTD", logo: "/images/sponsors/Matrix.jpeg" },
    { name: "CIPLA REGENACIP", logo: "/images/sponsors/Cipla_logo.png" },
    { name: "IPCA LABS LTD", logo: "/images/sponsors/IPCA.jpeg" },
    { name: "COLOPLAST INDIA PVT LTD", logo: "/images/sponsors/Coloplast.png" },
    { name: "BALTON", logo: "/images/sponsors/Balton-new.png" },
    { name: "CYTOGENESIS PVT LTD", logo: "/images/sponsors/Cytogenesis.png" },
    { name: "TRIUMPH HEALTHCARE", logo: "/images/sponsors/Triumph_logo.png" },
    { name: "JOLLY PHARMA INDIA", logo: "/images/sponsors/Jolly_logo.jpeg" },
    { name: "COLOGENESIS HEALTHCARE PVT LTD", logo: "/images/sponsors/cologenesis-logo.png" },
    { name: "DYNAMIC TECHNO MEDICALS PVT LTD", logo: "/images/sponsors/Dynamic-Techno-Medicals.png" },
    { name: "MEDILEAD", logo: "/images/sponsors/Medilead.jpeg" },
    { name: "SUN PHARMA", logo: "/images/sponsors/SunPharma.jpeg" },
    { name: "URGO MEDICAL", logo: "/images/sponsors/Urgo-logo.png" },
    { name: "OXYGEN BIOTEC", logo: "/images/sponsors/OxyGen_Logo.jpeg" }
  ];

  return (
    <div className="sponsors-page">
      <div className="sponsors-header">
        <h1 className="sponsors-page-title">Our Sponsors</h1>
        <p className="sponsors-subtitle">
          We are grateful to our sponsors for their generous support in making this conference possible
        </p>
      </div>

      <section className="sponsor-tier main-sponsor-section">
        {/* <div className="tier-header">
          <div className="tier-badge main-badge">
            <span className="badge-text">Title Sponsor</span>
          </div>
        </div> */}
        
        <div className="main-sponsor-card">
          <a 
            href={mainSponsor.website} 
            target="_blank" 
            rel="noopener noreferrer"
            className="sponsor-link"
          >
            <div className="main-sponsor-logo-container">
              <img 
                src={mainSponsor.logo} 
                alt={mainSponsor.name}
                className="main-sponsor-logo"
              />
            </div>
            <h2 className="main-sponsor-name">{mainSponsor.name}</h2>
          </a>
        </div>
      </section>

      <section className="sponsor-tier platinum-sponsor-section">
        {/* <div className="tier-header">
          <div className="tier-badge platinum-badge">
            <span className="badge-text">Platinum Sponsors</span>
          </div>
        </div> */}
        
        <div className="platinum-sponsors-grid">
          {platinumSponsors.map((sponsor, index) => (
            <a
              key={index}
              href={sponsor.website}
              target="_blank"
              rel="noopener noreferrer"
              className="sponsor-card platinum-card"
            >
              <div className="sponsor-logo-container">
                <img 
                  src={sponsor.logo} 
                  alt={sponsor.name}
                  className="sponsor-logo"
                />
              </div>
              <h3 className="sponsor-name">{sponsor.name}</h3>
            </a>
          ))}
        </div>
      </section>

      <section className="sponsor-tier gold-sponsor-section">
        {/* <div className="tier-header">
          <div className="tier-badge gold-badge">
            <span className="badge-text">Gold Sponsors</span>
          </div>
        </div> */}
        
        <div className="gold-sponsors-grid">
          {goldSponsors.map((sponsor, index) => (
            <a
              key={index}
              href={sponsor.website}
              target="_blank"
              rel="noopener noreferrer"
              className="sponsor-card gold-card"
            >
              <div className="sponsor-logo-container">
                <img 
                  src={sponsor.logo} 
                  alt={sponsor.name}
                  className="sponsor-logo"
                />
              </div>
              <h3 className="sponsor-name">{sponsor.name}</h3>
            </a>
          ))}
        </div>
      </section>

      <section className="sponsor-tier common-sponsor-section">
        {/* <div className="tier-header">
          <div className="tier-badge common-badge">
            <span className="badge-text">Supporting Sponsors</span>
          </div>
        </div>
         */}
        <div className="common-sponsors-grid">
          {commonSponsors.map((sponsor, index) => (
            <div
              key={index}
              className="sponsor-card common-card"
            >
              <div className="sponsor-logo-container">
                <img 
                  src={sponsor.logo} 
                  alt={sponsor.name}
                  className="sponsor-logo"
                />
              </div>
              <p className="sponsor-name">{sponsor.name}</p>
            </div>
          ))}
        </div>
      </section>

      {/* <section className="sponsors-cta">
        <div className="cta-content">
          <h2 className="cta-title">Interested in Sponsoring?</h2>
          <p className="cta-description">
            Join our list of esteemed sponsors and gain valuable exposure at Vascular Voyages 2026
          </p>
          <a href="mailto:vascularvoyages.kims@gmail.com" className="cta-button">
            Contact Us for Sponsorship Opportunities
          </a>
        </div>
      </section> */}
    </div>
  );
}

export default Sponsors;